import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import es from '@angular/common/locales/es';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import { apiKeyInterceptor } from './core/http/api-key.interceptor';
import { loadingInterceptor } from './core/http/loading.interceptor';
import { LipatinPreset } from './theme/lipatin-preset';
import { TRADUCCION_ES } from './theme/traduccion-es';

registerLocaleData(es);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      // El flujo se recorre en micro-pantallas: cada avance debe empezar arriba,
      // no donde quedo el desplazamiento de la pantalla anterior.
      withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' }),
    ),
    provideHttpClient(withInterceptors([loadingInterceptor, apiKeyInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: LipatinPreset,
        options: {
          // El tramite es claro y punto: `styles.scss` ya fija `color-scheme: light`.
          // Con el valor por defecto (`system`) Aura pintaria el formulario en
          // oscuro a quien tenga el sistema en oscuro, contra los tokens de la Liga.
          darkModeSelector: false,
        },
      },
      // PrimeNG no lee `LOCALE_ID`: sin esto el calendario sale en ingles, y la
      // fecha de nacimiento es el primer dato que se pide en todo el tramite.
      translation: TRADUCCION_ES,
    }),
    { provide: LOCALE_ID, useValue: 'es-CO' },
  ],
};
